'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _LogentryForm = require('../ui/LogentryForm');

var _LogentryForm2 = _interopRequireDefault(_LogentryForm);

var _LogentryModel = require('../model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _ObjectTypeMapping = require('../../constants/ObjectTypeMapping');

var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditLogentry = function EditLogentry(element, args) {
  var _this = this;

  _classCallCheck(this, EditLogentry);

  this.onchange = function () {
    _this.data = _this.logentryForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('logentries', _this.data.getJSON()).then(function (logentry) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && logentry.id) {
        window.PRIM.navigate('/logentries/' + logentry.id, true);
      }

      if (logentry) {
        _this.data.values.id = logentry.id;
        _this.logentryForm.setValue(_this.data);
      }
    });
  };

  this.data = new _LogentryModel2.default();

  if (args) {
    if (args.id) {
      window.PRIM.dataAccess.resolve('logentries', args.id, false).then(function (logentry) {
        _this.data = logentry;
        _this.logentryForm.setValue(_this.data);
      }, function () {
        if (confirm('Deze logregel bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw logregel aanmaken?')) {
          window.PRIM.navigate('/logentries/');
        } else {
          history.back();
        }
      }).catch(function () {});
    } else if (args.target_id && args.object_type) {
      this.data.values.target_id = args.target_id;
      this.data.values.object_type_id = _ObjectTypeMapping2.default[args.object_type];

      var now = new Date();
      now = new Date(now.getTime() - now.getTimezoneOffset() * 60000);

      this.data.values.timestamp = now.toISOString().substring(0, 19).replace('T', ' ');
    }
  } else {
    var _now = new Date();
    _now = new Date(_now.getTime() - _now.getTimezoneOffset() * 60000);

    this.data.values.timestamp = _now.toISOString().substring(0, 19).replace('T', ' ');
  }

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Logregel bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze logregel wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('logentries', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze logregel.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  this.logentryForm = new _LogentryForm2.default(divContent, { logentry: this.data, onchange: this.onchange });

  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditLogentry;


//////////////////
// WEBPACK FOOTER
// ./js/modules/logentry/action/EditLogentry.js
// module id = 66
// module chunks = 0